export default __webpack_public_path__ + "img/photo.6dfedf13.png";